import { render, staticRenderFns } from "./TagPolygons.vue?vue&type=template&id=6c18b17b&scoped=true"
import script from "./TagPolygons.vue?vue&type=script&lang=js"
export * from "./TagPolygons.vue?vue&type=script&lang=js"
import style0 from "./TagPolygons.vue?vue&type=style&index=0&id=6c18b17b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c18b17b",
  null
  
)

export default component.exports